import { useEffect } from "react"
import { useNavigate } from "react-router-dom"

const BotonLogout = () => {

   let history = useNavigate()

   const logout = () => {
      localStorage.removeItem('login')
      localStorage.removeItem('token')
      localStorage.removeItem('rtoken')
      localStorage.removeItem('nombre_usuario')
      localStorage.setItem("loginStatus", "Cerró Sesión correctamente")
      const element = document.getElementsByTagName("body");
      if (element[0].classList.contains('sidebar-open')) {
         element[0].classList.remove('sidebar-open')
         element[0].classList.add('sidebar-closed')
         element[0].classList.add('sidebar-collapse')

      }
      history("/")
   }

   // VERIFICA LA VALIDEZ DEL TOKEN CADA SEGUNDO. CASO CONTRARIO CIERRA SESION
   useEffect(() => {
      const checkSession = () => {
         const token = localStorage.getItem('token'); // O de donde obtengas tu token

         if (token) {
            const payload = JSON.parse(atob(token.split('.')[1]));
            const exp = payload.exp * 1000; // Convertir a milisegundos

            if (Date.now() + 5000 >= exp) {
               logout()
            }
         } else {
            logout()
         }
      };

      // Ejecutar la verificación inmediatamente al montar el componente
      checkSession();

      // Configurar el intervalo para verificar cada 5 minutos (300000 ms)
      const interval = setInterval(checkSession, 1000);

      // Limpiar el intervalo al desmontar el componente
      return () => clearInterval(interval);
   }, [history]);

   return (
      <div className="small">
         <button className="btn btn-xs btn-outline-danger" onClick={logout}>Cerrar Sesión</button>
      </div>
   )
}
export default BotonLogout